// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Farm View — "Field details" tab
   Width-driven layout: the tab is a size container, so "small" means the
   trailing panel is narrow, regardless of the viewport. (container-type
   does not apply layout containment, so position:fixed popups inside the
   tab — e.g. the graph's pressure-alert popup — still use the viewport.) */
.field-details-tab {
  container-type: inline-size;
  container-name: field-details-tab;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  font-family: 'Source Sans Pro', sans-serif;
}
.field-details-tab__header {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  height: 72px;
  padding: 0 32px;
  background: var(--color-grey-100);
  background: var(--color-grey-100);
  border-bottom: 1px solid var(--color-grey-91);
  border-bottom: 1px solid var(--color-grey-91);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 16px 16px 0 0;
  z-index: 1;
}

.field-details-tab__field-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.02em;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

.field-details-tab__body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1 1 auto;
  min-height: 0;
  gap: 64px;
  padding: 24px 40px 40px;
  overflow-y: auto;
}

.field-details-tab__body > * {
  flex: none;
}

.field-details-tab__graphs {
  min-width: 0;
}

/* Recommendation + Reported | Map */
.field-details-tab__wrap {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 40px;
  min-width: 0;
}

.field-details-tab__events {
  display: flex;
  flex-direction: column;
  flex: none;
  width: 472px;
  gap: 40px;
}

.field-details-tab__events .recommendation-tile-card {
  min-width: 0;
}

.field-details-tab__map {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  gap: 8px;
}

.field-details-tab__map-title {
  height: 16px;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

.field-details-tab__map-frame {
  box-sizing: border-box;
  height: 626px;
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  z-index: 0;
}

.field-details-tab__map-frame > * {
  height: 100%;
}

/* Reported list: grey-96 well behind white 64px rows, 16px radius */
.field-details-tab__events > * {
  align-self: stretch;
  width: 100%;
  box-sizing: border-box;
}

/* Reported takes whatever height the column has left below the
   recommendation (the column stretches to the map's 650px). */
.field-details-tab__reported {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
}

.field-details-tab__reported .list-group-item {
  background: var(--color-grey-96);
  background: var(--color-grey-96);
  border-radius: 0;
}

/* Irrigation recommendation (Figma 472x210: 24 title + 154 card + 32 helpful)
   Scoped overrides so the Field View / Planning tiles keep their styles. */
.field-details-tab .recommendation-tile-wrapper {
  display: block;
  gap: 0;
  padding-bottom: 0;
  width: 100%;
  /* RecommendationTileWrapper.css caps the tile at 400x326 on viewports
     <= 1560px; this tab sizes it by its own column instead. */
  max-width: none;
  height: auto;
  min-height: 0;
  max-height: none;
}

.field-details-tab .recommendation-tile-card {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  min-height: 210px;
  justify-content: flex-start;
}

.field-details-tab .recommendation-tile-card .header {
  align-items: flex-end;
  height: 24px;
  padding-bottom: 8px;
  box-sizing: border-box;
}

.field-details-tab .irrigation-card {
  height: 154px;
  min-height: 154px;
  min-width: 0;
  border-radius: 16px;
  overflow: hidden;
}

.field-details-tab .irrigation-card__header {
  font-size: 14px;
  letter-spacing: 0.01em;
  height: 32px;
  box-sizing: border-box;
}

.field-details-tab .irrigation-card__stats-row {
  gap: 16px;
  min-height: 122px;
  height: 122px;
}

.field-details-tab .irrigation-card__arrow {
  align-self: stretch;
  height: 122px;
}

.field-details-tab .irrigation-card__arrow:hover:not(:disabled) {
  height: 122px;
}

.field-details-tab .irrigation-card__stat-block {
  min-width: 0;
  padding: 8px;
  box-sizing: border-box;
}

.field-details-tab .irrigation-card__stat-block:last-child {
  padding: 0 8px;
}

.field-details-tab .feedback-row-wrapper {
  height: 32px;
}

.field-details-tab .feedback-row-figma {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 4px 0 4px 8px;
}

/* Not enough room for the 472px column + 40px gap + a usable map: stack
   Recommendation/Reported above the map. */
@container field-details-tab (max-width: 900px) {
  .field-details-tab__wrap {
    flex-direction: column;
  }

  .field-details-tab__events {
    width: 100%;
  }

  .field-details-tab__reported {
    flex: none;
    height: 400px;
  }

  .field-details-tab__map {
    flex: none;
  }
}

/* Figma "small" (520px): body padding 24/40/80/40, 40px gaps. */
@container field-details-tab (max-width: 520px) {
  .field-details-tab__body {
    gap: 40px;
    padding-bottom: 80px;
  }
}

/* main.css caps .nextActionsContainer at 256px on viewports <= 1560px (for the
   Field View); here the list fills its rounded box. */
.field-details-tab .nextActionsContainer {
  max-height: none !important;
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/FieldDetailsTab.css"],"names":[],"mappings":"AAAA;;;;2EAI2E;AAC3E;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,iCAAiC;EACjC,6CAA6C;EAC7C,6CAA6C;EAC7C,wCAAwC;EACxC,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;8DAC8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;2EAC2E;AAC3E;EACE,cAAc;EACd,MAAM;EACN,iBAAiB;EACjB,WAAW;EACX;8DAC4D;EAC5D,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;2CAC2C;AAC3C;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA;sDACsD;AACtD;EACE,2BAA2B;AAC7B","sourcesContent":["/* Farm View — \"Field details\" tab\n   Width-driven layout: the tab is a size container, so \"small\" means the\n   trailing panel is narrow, regardless of the viewport. (container-type\n   does not apply layout containment, so position:fixed popups inside the\n   tab — e.g. the graph's pressure-alert popup — still use the viewport.) */\n.field-details-tab {\n  container-type: inline-size;\n  container-name: field-details-tab;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  font-family: 'Source Sans Pro', sans-serif;\n}\n.field-details-tab__header {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  height: 72px;\n  padding: 0 32px;\n  background: var(--color-grey-100);\n  background: var(--color-grey-100);\n  border-bottom: 1px solid var(--color-grey-91);\n  border-bottom: 1px solid var(--color-grey-91);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-radius: 16px 16px 0 0;\n  z-index: 1;\n}\n\n.field-details-tab__field-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  letter-spacing: -0.02em;\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n}\n\n.field-details-tab__body {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 1 1 auto;\n  min-height: 0;\n  gap: 64px;\n  padding: 24px 40px 40px;\n  overflow-y: auto;\n}\n\n.field-details-tab__body > * {\n  flex: none;\n}\n\n.field-details-tab__graphs {\n  min-width: 0;\n}\n\n/* Recommendation + Reported | Map */\n.field-details-tab__wrap {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 40px;\n  min-width: 0;\n}\n\n.field-details-tab__events {\n  display: flex;\n  flex-direction: column;\n  flex: none;\n  width: 472px;\n  gap: 40px;\n}\n\n.field-details-tab__events .recommendation-tile-card {\n  min-width: 0;\n}\n\n.field-details-tab__map {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0;\n  min-width: 0;\n  gap: 8px;\n}\n\n.field-details-tab__map-title {\n  height: 16px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 16px;\n  color: var(--color-grey-45);\n  color: var(--color-grey-45);\n}\n\n.field-details-tab__map-frame {\n  box-sizing: border-box;\n  height: 626px;\n  border: 1px solid var(--color-grey-91);\n  border: 1px solid var(--color-grey-91);\n  border-radius: 16px;\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n}\n\n.field-details-tab__map-frame > * {\n  height: 100%;\n}\n\n/* Reported list: grey-96 well behind white 64px rows, 16px radius */\n.field-details-tab__events > * {\n  align-self: stretch;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Reported takes whatever height the column has left below the\n   recommendation (the column stretches to the map's 650px). */\n.field-details-tab__reported {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0;\n  min-height: 0;\n}\n\n.field-details-tab__reported .list-group-item {\n  background: var(--color-grey-96);\n  background: var(--color-grey-96);\n  border-radius: 0;\n}\n\n/* Irrigation recommendation (Figma 472x210: 24 title + 154 card + 32 helpful)\n   Scoped overrides so the Field View / Planning tiles keep their styles. */\n.field-details-tab .recommendation-tile-wrapper {\n  display: block;\n  gap: 0;\n  padding-bottom: 0;\n  width: 100%;\n  /* RecommendationTileWrapper.css caps the tile at 400x326 on viewports\n     <= 1560px; this tab sizes it by its own column instead. */\n  max-width: none;\n  height: auto;\n  min-height: 0;\n  max-height: none;\n}\n\n.field-details-tab .recommendation-tile-card {\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  min-height: 210px;\n  justify-content: flex-start;\n}\n\n.field-details-tab .recommendation-tile-card .header {\n  align-items: flex-end;\n  height: 24px;\n  padding-bottom: 8px;\n  box-sizing: border-box;\n}\n\n.field-details-tab .irrigation-card {\n  height: 154px;\n  min-height: 154px;\n  min-width: 0;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.field-details-tab .irrigation-card__header {\n  font-size: 14px;\n  letter-spacing: 0.01em;\n  height: 32px;\n  box-sizing: border-box;\n}\n\n.field-details-tab .irrigation-card__stats-row {\n  gap: 16px;\n  min-height: 122px;\n  height: 122px;\n}\n\n.field-details-tab .irrigation-card__arrow {\n  align-self: stretch;\n  height: 122px;\n}\n\n.field-details-tab .irrigation-card__arrow:hover:not(:disabled) {\n  height: 122px;\n}\n\n.field-details-tab .irrigation-card__stat-block {\n  min-width: 0;\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.field-details-tab .irrigation-card__stat-block:last-child {\n  padding: 0 8px;\n}\n\n.field-details-tab .feedback-row-wrapper {\n  height: 32px;\n}\n\n.field-details-tab .feedback-row-figma {\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 4px 0 4px 8px;\n}\n\n/* Not enough room for the 472px column + 40px gap + a usable map: stack\n   Recommendation/Reported above the map. */\n@container field-details-tab (max-width: 900px) {\n  .field-details-tab__wrap {\n    flex-direction: column;\n  }\n\n  .field-details-tab__events {\n    width: 100%;\n  }\n\n  .field-details-tab__reported {\n    flex: none;\n    height: 400px;\n  }\n\n  .field-details-tab__map {\n    flex: none;\n  }\n}\n\n/* Figma \"small\" (520px): body padding 24/40/80/40, 40px gaps. */\n@container field-details-tab (max-width: 520px) {\n  .field-details-tab__body {\n    gap: 40px;\n    padding-bottom: 80px;\n  }\n}\n\n/* main.css caps .nextActionsContainer at 256px on viewports <= 1560px (for the\n   Field View); here the list fills its rounded box. */\n.field-details-tab .nextActionsContainer {\n  max-height: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
